import React from 'react';
import { SelectInput, SelectInputProps } from '../../atom/form';
import { RelationshipType } from '../../../models';

export function RelationshipTypeDropdown(props: Omit<SelectInputProps<RelationshipType>, 'options'>) {
  const options = [
    { value: RelationshipType.Parent, display: 'Parent' },
    { value: RelationshipType.Sibling, display: 'Sibling' },
    { value: RelationshipType.OtherFamilyMember, display: 'Other Family Member' },
    { value: RelationshipType.LegalGuardian, display: 'Legal Guardian' },
    { value: RelationshipType.SupportCoordinator, display: 'Support Coordinator' },
    { value: RelationshipType.Other, display: 'Other' },
  ];
  return <SelectInput options={options} {...props} />;
}
